import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dialog-loading',
    templateUrl: './dialog-loading.component.html',
    styleUrls: ['./dialog-loading.component.scss']
})
export class DialogLoadingComponent implements OnInit {

    message: string = '';

    constructor() { }

    ngOnInit(): void {
    }

}
